import React from 'react';
import './Panel.css'; 
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Panel = ({ closePanel, closeSidebarMenu, className = '' }) => {
  const { t } = useTranslation(); 
  const navigate = useNavigate();

  const handleLinkClick = (product) => {
    closePanel();
    if (closeSidebarMenu) {
      closeSidebarMenu(); 
    }
    navigate('/Product', { state: { product } }); 
  };

  return (
    <div className={`parent-panel ${className}`}>
      <div className="panel">
        <div className="Panel-item" onClick={() => handleLinkClick('Press')}>{t('Press')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Destemmer Crusher')}>{t('Destemmer Crusher')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Pump')}>{t('Pump')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Tanks Barriques Anfora')}>{t('Tanks Barriques Anfora')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Filter')}>{t('Filter')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Botling Labeling')}>{t('Botling Labeling')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Reception')}>{t('Reception')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Cooler & Heater')}>{t('Cooler & Heater')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Destiller')}>{t('Destiller')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Fruit Equipment')}>{t('Fruit Equipment')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Sorter')}>{t('Sorter')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Gardening and Vineyeard')}>{t('Gardening and Vineyeard')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Wine Dispenser')}>{t('Wine Dispenser')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Fittings Tubes')}>{t('Fittings Tubes')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Small Equipments')}>{t('Small Equipments')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Used Equipments')}>{t('Used Equipments')}</div>
      </div>
    </div>
  );
};

export default Panel;